import VideoChaptersPlugin from './video-chapters-plugin'
import { VideoChaptersButton } from './video-chapters-button'

export { VideoChaptersButton } from './video-chapters-button'

export const PLUGIN_NAME = 'VideoChapters'
const COMPONENT_NAME = 'VideoChaptersButton'

/**
 * A video.js plugin for chapters functionality.
 *
 * @function videoChapters
 * @param    {Object} [options={}]
 * An object of options left to the plugin author to define.
 */
function videoChapters (options = {}) {
  return new VideoChaptersPlugin(this, options)
}

export function register (videojsIn = window.videojs) {
  videojsIn.registerComponent(COMPONENT_NAME, VideoChaptersButton)
  videojsIn.registerPlugin(PLUGIN_NAME, videoChapters)
}

export default videoChapters
